import { render, staticRenderFns } from "./QuestionnaireTable.vue?vue&type=template&id=0d53c503&scoped=true&lang=pug"
import script from "./QuestionnaireTable.vue?vue&type=script&lang=ts"
export * from "./QuestionnaireTable.vue?vue&type=script&lang=ts"
import style0 from "./QuestionnaireTable.vue?vue&type=style&index=0&id=0d53c503&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d53c503",
  null
  
)

export default component.exports